import cx from 'classnames';
import { useI18n } from '../../i18n';
import styles from './SceneOnboarding.module.css';

type SceneOnboardingProps = {
  visible: boolean;
};

export const SceneOnboarding = ({ visible }: SceneOnboardingProps) => {
  const i18n = useI18n();

  return (
    <div className={cx(styles.wrapper, visible && styles.visible)}>
      <h2 className={styles.title}>{i18n.onboarding.title}</h2>
      <div className={styles.divider} />
      <p className={styles.hint}>{i18n.onboarding.hint}</p>
    </div>
  );
};
